export const SORT_KEYS = [
  "default",
  "price-asc",
  "price-desc",
  "name",
] as const;

export type SortKey = (typeof SORT_KEYS)[number];

export function isSortKey(value: string): value is SortKey {
  return (SORT_KEYS as readonly string[]).includes(value);
}

export function orderForSort(sort: SortKey): string | undefined {
  if (sort === "name") return "title";
  if (sort === "default") return "-created_at";
  return undefined;
}
